import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ErrorDialogData {
  message: string;
  errors: any[];
}

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.html',
  styleUrls: ['./error-dialog.scss'],
})
export class ErrorDialog implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<ErrorDialog>,
    @Inject(MAT_DIALOG_DATA) public data: ErrorDialogData,
  ) {}

  ngOnInit() {}

  closeDialog() {
    this.dialogRef.close();
  }
}
